interface LoadingIndicatorProps {
  isVisible: boolean;
}

export function LoadingIndicator({ isVisible }: LoadingIndicatorProps) {
  if (!isVisible) return null;

  return (
    <div className="absolute top-0 left-0 right-0 z-10 bg-utility-brand-600 backdrop-blur-sm rounded-lg">
      <div className="flex items-center justify-center py-3 relative">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1">
            <div
              className="w-2 h-2 bg-white rounded-full animate-bounce"
              style={{ animationDelay: "0ms" }}
            />
            <div
              className="w-2 h-2 bg-white rounded-full animate-bounce"
              style={{ animationDelay: "150ms" }}
            />
            <div
              className="w-2 h-2 bg-white rounded-full animate-bounce"
              style={{ animationDelay: "300ms" }}
            />
          </div>

          <div className="relative">
            <div className="animate-pulse">
              <svg
                className="text-white animate-bounce"
                fill="none"
                height="16"
                style={{ animationDelay: "450ms" }}
                viewBox="0 0 24 24"
                width="16"
              >
                <path
                  d="M12 4L12 20M12 4L6 10M12 4L18 10"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>

          <span className="text-white text-sm font-bold animate-pulse">
            Loading more messages...
          </span>
        </div>
      </div>
    </div>
  );
}
